const primaryColor = '#0A1264'
const primaryColorHover = '#4db4f6'
const secondaryColor = '#e87722'

export {
    primaryColor,
    primaryColorHover,
    secondaryColor
}
